/**
 * AnimateNumber
 * ======================================
 * - count-up to target number on scroll
 * - set value via [data-counter-target] html attribute
 * - set animation delay via [animate-delay] html attribute
 * - if you want disable animate delay on mobile use [animate-delay-desktop]
 * - set visible threshold via [animate-threshold] html attribute
 */

const ISMOBILE = window.matchMedia("only screen and (max-width: 768px)").matches
const THRESHOLD = ISMOBILE ? '0.4' : '0.6'
const LOAD_THRESHOLD = '0.2'
const ELEMENTS_CLASS = 'counter'
const DURATION = 1500
// const DURATION = 2000

class AnimateNumber {
  constructor() {
    this.THRESHOLD = THRESHOLD
    this.LOAD_THRESHOLD = LOAD_THRESHOLD
    this.sections = document.querySelectorAll('.' + ELEMENTS_CLASS)

    if ('IntersectionObserver' in window) {
      this.sections.forEach((el) => {
        const BoundingClientRect = el.getBoundingClientRect()
        const visibleRatio = BoundingClientRect.height / window.innerHeight

        if (visibleRatio > 0.95) {
          this.THRESHOLD = window.innerHeight / BoundingClientRect.height / 100 * 30
          this.LOAD_THRESHOLD = window.innerHeight / BoundingClientRect.height / 100 * 20
        }

        // observe on page load
        const loadObserver = new IntersectionObserver(this.observeCallback, {
          threshold: this.LOAD_THRESHOLD
        });
        loadObserver.observe(el);

        setTimeout(() => {
          loadObserver.disconnect();
        }, 100);

        // observe
        const observerThreshold = el.getAttribute('animate-threshold') ? el.getAttribute('animate-threshold') : this.THRESHOLD
        const observer = new IntersectionObserver(this.observeCallback, {
          threshold: observerThreshold
        });
        observer.observe(el);
      })
    }
  }


  observeCallback = (entries) => {
    entries.map((entry) => {
      const section = entry.target;
      const delay = this.getDelay(section)

      if (entry.isIntersecting) {
        if (ISMOBILE && section.getAttribute('animate-delay-desktop')) {
          this.run(section)
        } else {
          setTimeout(() => {
            this.run(section)
          }, delay)
        }
      }
    });
  }

  getDelay = (section) => {
    var delay = section.getAttribute('animate-delay')

    if (!ISMOBILE && section.getAttribute('animate-delay-desktop')) {
      var delay = section.getAttribute('animate-delay-desktop')
    }

    if (delay === null) {
      return 0
    } else if (delay.includes('.')) {
      return parseInt(delay * 1000)
    } else {
      return parseInt(delay)
    }
  }

  run = (element) => {
    if (element.hasAttribute('data-counter-complete')) {
      return false;
    }

    this.startNumeric(element);

    element.setAttribute('data-counter-complete', 'true');
  }
  startNumeric = (element) => {
    let start;
    const origin = +element.innerText || 0;
    const duration = DURATION
    const target = element.getAttribute('data-counter-target')

    const step = (timestamp) => {
      start = start || timestamp;
      const progress = Math.min((timestamp - start) / duration, 1);
      const number = Math.floor(progress * (target - origin) + origin);
      element.innerHTML = new Intl.NumberFormat('cs-CZ').format(number)

      if (progress < 1) {
        window.requestAnimationFrame(step);
      } else {
        window.cancelAnimationFrame(window.requestAnimationFrame(step));
      }
    }

    window.requestAnimationFrame(step);
  }
}

new AnimateNumber()
